import Modal from '../../common/components/Modal';
import ItemList from '../../common/utils/ItemList';
import Button from '../../common/components/Button';
import Switch from '../../common/components/Switch';
import Stream from '../../common/utils/Stream';

export default class AllConfirmModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.loading = false;
  }

  className() {
    return 'Modal--small NickameModal FlarumBadgesConfirmModal';
  }

  title() {
    return this.attrs.title;
  }

  content() {
    return [
      <div className="Modal-body">
        <p className='modal-content'>{this.attrs.text}</p>
        <div className="Modal-footer FlarumBadgesConfirmButtons">
          {Button.component(
            {
              className: 'btn cancel',
              disabled: this.loading,
              onclick: () => this.hide(),
            },
            this.attrs.isAdmin ? app.translator.trans('dl-response.admin.warn.no') : app.translator.trans('dl-response.forum.BindRoleModal.no')
          )}
          {Button.component(
            {
              className: 'btn confirm',
              loading: this.loading,
              onclick: () => {
                this.hide();
                this.loading = false;
                this.confirm();
              },
            },
            this.attrs.isAdmin ? app.translator.trans('dl-response.admin.warn.yes') : app.translator.trans('dl-response.forum.BindRoleModal.yes')
          )}
        </div>
      </div>,
    ];
  }

  /**
   * Confirm
   */
  confirm() {
    // Act as promise
    if (this.attrs.promise) {
      this.loading = true;

      this.attrs.onconfirm(
        () => this.hide(),
        () => {
          this.loading = false;
          m.redraw();
        }
      );
      return;
    }

    this.attrs.onconfirm();
    this.hide();
  }
}
